import axios from "axios";
import { toast } from "react-toastify";
import ApiConfig from "../config/ApiConfig";
import { errorMessage } from "../lib/helper";
import { STATUS_200, STATUS_300 } from "../data/constants";
import agentAxios from "../lib/AxiosInterceptor";
import { setAllPropertyTypesDataLoading } from "../redux/userDashboard";
import {
  setMyAgentsList,
  setMyAgentsListError,
  setMyAgentsListLoading,
  setMyCommissionSaleList,
  setMyCommissionSaleListLoading,
  setMyCommissionSaleListError,
  setMyCommissionAuditList,
  setMyCommissionAuditListLoading,
  setMyCommissionAuditListError
} from "../redux/agentDashboard";

export const ResetAgentPasswordService = async (payload, extraConfig) => {
  if (payload !== undefined) {
    try {
      const response = await agentAxios.post(
        `${ApiConfig.resetAgentPassword}`,
        payload,
        extraConfig
      );
      if (response?.status >= STATUS_200 && response?.status < STATUS_300) {
        toast.success(response?.data?.message, {
          autoClose: 2500,
          className: "toast-message",
          position: toast.POSITION.TOP_RIGHT,
        });
      } else {
        throw response;
      }
    } catch (e) {
      if (e?.status == 422) {
        toast.error(e?.data?.message?.error, {
          // toast.error(e?.data?.data?.new_password[0], {
        autoClose: 2500,
      });
    }
    else{
    toast.error(errorMessage(e), {
      autoClose: 2500,
    });
  }
    }
  }
};

export const updateAgentProfileService = async (payload,extraConfig) => {
  if (payload !== undefined) {
    try {
      const response = await agentAxios.post(
        `${ApiConfig.updateAgentProfile}`,
        payload,
        extraConfig
      );
      if (response?.status >= STATUS_200 && response?.status < STATUS_300) {
        toast.success(response?.data?.message, {
          autoClose: 2500,
          className: "toast-message",
          position: toast.POSITION.TOP_RIGHT,
        });
      } else {
        throw response;
      }
    } catch (e) {
      toast.error(errorMessage(e), {
        autoClose: 2500,
      });
    }
  }
};
export const CancelAuditAppointmentService = async (payload) => {
  if (payload !== undefined) {
    try {
      const response = await agentAxios.post(
        `${ApiConfig.cancelAuditAppointment}`,
        payload
      );
      if (response?.status >= STATUS_200 && response?.status < STATUS_300) {
        toast.success(response?.data?.message, {
          autoClose: 2500,
          className: "toast-message",
          position: toast.POSITION.TOP_RIGHT,
        });
        return true;
      } else {
        throw response;
      }
    } catch (e) {
      toast.error(errorMessage(e), {
        autoClose: 2500,
      });
      return false;
    }
  }
};
export const markAuditCompletedService = async (payload) => {
  if (payload !== undefined) {
    try {
      const response = await agentAxios.post(
        `${ApiConfig.markAuditComplete}`,
        payload
      );
      if (response?.status >= STATUS_200 && response?.status < STATUS_300) {
        toast.success(response?.data?.message, {
          autoClose: 2500,
          className: "toast-message",
          position: toast.POSITION.TOP_RIGHT,
        });
        return true;
      } else {
        throw response;
      }
    } catch (e) {
      toast.error(errorMessage(e), {
        autoClose: 2500,
      });
      return false;
    }
  }
};

export const markMyVisitAppointmentComplete = async (payload) => {
  if (payload !== undefined) {
    try {
      const response = await agentAxios.post(
        `${ApiConfig.markVisitComplete}`,
        payload
      );
      if (response?.status >= STATUS_200 && response?.status < STATUS_300) {
        toast.success(response?.data?.message, {
          autoClose: 2500,
          className: "toast-message",
          position: toast.POSITION.TOP_RIGHT,
        });
        return true;
      } else {
        throw response;
      }
    } catch (e) {
      toast.error(errorMessage(e), {
        autoClose: 2500,
      });
      return false;
    }
  }
};

export const CancelMyVisitAppointment = async (payload) => {
  if (payload !== undefined) {
    try {
      const response = await agentAxios.post(
        `${ApiConfig.cancelVisitAppointment}`,
        payload
      );
      if (response?.status >= STATUS_200 && response?.status < STATUS_300) {
        toast.success(response?.data?.message, {
          autoClose: 2500,
          className: "toast-message",
          position: toast.POSITION.TOP_RIGHT,
        });
        return true;
      } else {
        throw response;
      }
    } catch (e) {
      toast.error(errorMessage(e), {
        autoClose: 2500,
      });
      return false;
    }
  }
};
export const ResetUserPasswordService = async (payload, extraConfig) => {
  if (payload !== undefined) {
    try {
      const response = await axios.post(
        `${ApiConfig.resetAgentPassword}`,
        payload,
        extraConfig
      );
      if (response?.status >= STATUS_200 && response?.status < STATUS_300) {
        toast.success(response?.data?.message, {
          autoClose: 2500,
          className: "toast-message",
          position: toast.POSITION.TOP_RIGHT,
        });
        return true;
      } else {
        throw response;
      }
    } catch (e) {
      if (e?.status == 422) {
        toast.error(e?.data?.message?.error, {
        // toast.error(e?.data?.data?.new_password[0], {
          autoClose: 2500,
        });
      }
      else{
      toast.error(errorMessage(e), {
        autoClose: 2500,
      });
    }
    }
  }
};
export const updateUserProfileService = async (payload, extraConfig) => {
  if (payload !== undefined) {
    try {
      const response = await axios.post(
        `${ApiConfig.updateAgentProfile}`,
        payload,
        extraConfig
      );
      if (response?.status >= STATUS_200 && response?.status < STATUS_300) {
        toast.success(response?.data?.message, {
          autoClose: 2500,
          className: "toast-message",
          position: toast.POSITION.TOP_RIGHT,
        });
        return true;
      } else {
        throw response;
      }
    } catch (e) {
      toast.error(errorMessage(e), {
        autoClose: 2500,
      });
    }
  }
};

export const GetMyAgentsList = () => {
  return async (dispatch) => {
    try {
      dispatch(setMyAgentsListLoading(true));
      const resp = await agentAxios.get(`${ApiConfig.myParentsAgentsList}`);
      if (resp?.status >= STATUS_200 && resp?.status < STATUS_300) {
        dispatch(setMyAgentsList(resp?.data?.referrals));
        console.log('ref',resp?.data?.referrals)
        dispatch(setMyAgentsListLoading(false));
      } else {
        throw resp;
      }
    } catch (e) {
      dispatch(
        setMyAgentsListError({
          isError: true,
          message: errorMessage(e),
        })
      );
      toast.error(errorMessage(e), {
        autoClose: 2000,
      });
      dispatch(setMyAgentsListLoading(false));
    }
  };
};

export const GetMyCommissionSale = (payment_status) => {
  return async (dispatch) => {
    try {
      dispatch(setMyCommissionSaleListLoading(true));
      const resp = await agentAxios.get(`${ApiConfig.myCommissionSale}`);
      if (resp?.status >= STATUS_200 && resp?.status < STATUS_300) {
        dispatch(setMyCommissionSaleList(resp?.data?.data));
        dispatch(setMyCommissionSaleListLoading(false));
      } else {
        throw resp;
      }
    } catch (e) {
      dispatch(
        setMyCommissionSaleListError({
          isError: true,
          message: errorMessage(e),
        })
      );
      toast.error(errorMessage(e), {
        autoClose: 2000,
      });
      dispatch(setMyCommissionSaleListLoading(false));
    }
  };
};

export const GetChildAgentDataForParent = async (parentUserId) => {
  if (parentUserId) {
    try {
      const resp = await agentAxios.get(
        `${ApiConfig.childAgentsList}?parent_id=${parentUserId}`
      );
      if (resp?.status >= STATUS_200 && resp?.status < STATUS_300) {
        return resp?.data?.data;
      } else {
        throw resp;
      }
    } catch (e) {
      toast.error(errorMessage(e), {
        autoClose: 2000,
      });
      return false;
    }
  }
};
export const GetMyCommissionAudit = (payment_status) => {
  return async (dispatch) => {
    try {
      dispatch(setMyCommissionAuditListLoading(true));
      const resp = await agentAxios.get(`${ApiConfig.myCommissionAudit}`);
      if (resp?.status >= STATUS_200 && resp?.status < STATUS_300) {
        dispatch(setMyCommissionAuditList(resp?.data?.data));
        dispatch(setMyCommissionAuditListLoading(false));
      } else {
        throw resp;
      }
    } catch (e) {
      dispatch(
        setMyCommissionAuditListError({
          isError: true,
          message: errorMessage(e),
        })
      );
      toast.error(errorMessage(e), {
        autoClose: 2000,
      });
      dispatch(setMyCommissionAuditListLoading(false));
    }
  };
};

export const getAgentDetails = async (agentCode) => {
  try {
    const response = await agentAxios.get(
      `${ApiConfig.getAgentCodeSearch}?agent_code=${agentCode}`,
    );

    if (response?.status >= STATUS_200 && response?.status < STATUS_300) {
      return response?.data?.data;
    } else {
      throw response;
    }
  } catch (e) {
    toast.error(errorMessage(e), {
      autoClose: 2500,
    });
    return null;
  }
};

